import { createContext } from "react";

import { ListNode } from "components/objectTree/types";
import { ModelTreeNodeData } from "features/modelTree/types";

export type V2SelectionContext = {
    selectedRowPaths: Set<string>;
    list: ListNode<ModelTreeNodeData>[];
    onRowSelect: (path: string, event: React.MouseEvent) => void;
    onToggleVisibilityForSelection?: (isHidden: boolean) => void;
};

export const SelectionContext = createContext<V2SelectionContext | null>(null);
